module.exports = __webpack_public_path__ + "static/media/file-download-solid.4aa8425b.svg";